import { Typography } from '@mui/material';
import { LINE_ITEM_TYPES } from '@weft/types';
import type { Nullable } from '@weft/utils';
import { isNotNullOrUndefined, isNullOrUndefined } from '@weft/utils';
import VyDialog from 'apps/app/src/components/new-design/feedback/VyDialog';
import { runMutation } from 'apps/app/src/utils/vy-mutation';
import React from 'react';
import { useQueryClient } from 'react-query';
import { useUpdateLineItem } from '../../../../../hooks/requests/use-update-line-item';
import { useParamsDynamicInvoiceId } from '../../../../../hooks/use-dynamic-invoice-id';
import type { ResetLineItemData } from './TiersUsageLineItemBody';

type ResetDialogProps = {
  resetLineItemData: Nullable<ResetLineItemData>;
  setResetLineItemData: (resetData: Nullable<ResetLineItemData>) => void;
};

export const ResetDialog:React.FC<ResetDialogProps> = ({
  resetLineItemData,
  setResetLineItemData,
}) => {
  const queryClient = useQueryClient();
  const dynamicInvoiceId = useParamsDynamicInvoiceId();

  const updateLineItemMutation = useUpdateLineItem();

  const handleClose = () => {
    setResetLineItemData(null);
  };

  const handleConfirm = async () => {
    if (isNullOrUndefined(resetLineItemData)) {
      return;
    }

    await runMutation(
      updateLineItemMutation,
      {
        lineItemId: resetLineItemData.lineItemId,
        updateLineItemRequest: {
          type: LINE_ITEM_TYPES.Usage,
          tiersUsageMap: {
            [resetLineItemData.productVariantId]: [
              {
                tierIndex: resetLineItemData.tierIndex,
                discountConfiguration: null,
              },
            ],
          },
        },
      },
      {
        pending: 'Resetting discount...',
        success: 'Discount reset',
        error: 'Failed to reset discount',
      },
      {
        onSuccess: async () => { 
          await queryClient.invalidateQueries(['dynamicInvoice', dynamicInvoiceId]);
          handleClose();
        },
      });
  };

  return (
    <VyDialog
      open={isNotNullOrUndefined(resetLineItemData)}
      onClose={handleClose}
      label="Discard Changes"
      ctaText="Confirm"
      cancelButtonText="Cancel"
      onSubmit={handleConfirm}
    >
      <Typography variant="h6">This will discard discount changes, are you sure?</Typography>
    </VyDialog>
  );
};